module.exports = __webpack_public_path__ + "img/icon-pack-magento-10-active.6b28a70c.svg";